var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.InDevelopment)?_c('v-chip',{staticStyle:{"margin-left":"8px"},attrs:{"label":"","color":"orange darken-2","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("fa fa-flask")]),_vm._v(" Test Version ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }